import { css } from 'styled-components';

export const imageFilter = css`
  ${({ theme }) => {
    return css`
      background: ${theme.color.primary_600};
      background: transparent;
      > img {
        object-fit: cover;
        opacity: 0.8;
        transition: opacity 0.35s;
      }
    `;
  }};
`;

export const imageFilterHover = css`
  &:hover img {
    opacity: 0.4;
  }
`;
